<template>
  <div class="wrapper">
    <Header class="header" :val="headerTitle"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <section class="deliveryStep">
          <ol>
            <li class="start" :class="{ on: serviceAuthTracking.level == '1' }"><span>배송시작</span></li>
            <li class="ing" :class="{  on: serviceAuthTracking.level == '2' }" > <span>배송중</span> </li>
            <li class="complete" :class="{ on: serviceAuthTracking.level == '6' }"><span>배송완료</span></li> 
          </ol>
        </section>

        <section v-if="productObj.releaseClass == 'RDET0001'" class="hr">
          <div class="titArea">
            <h2 class="titH5">
              직접설치 
              <span class="pointC8 normal">(설치기사 방문설치)</span>
            </h2>
          </div>

          <!-- table (s) -->
          <table class="tableX noLine">
            <colgroup>
              <col style="width:auto" span="3" />
            </colgroup>
            <thead>
              <tr>
                <th scope="col">처리일시</th>
                <th scope="col">현재 위치</th>
                <th scope="col">상태</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="3" class="noData">운송장번호가 등록되지 않았습니다.</td>
              </tr>
            </tbody>
          </table>
          <!-- table (e) -->
        </section>

        <section class="hr" v-else>
          <div class="titArea">
            <h2 class="titH5">{{ serviceAuthTracking.deliComp }}</h2>
            <span class="desc fr">운송장번호 : {{ serviceAuthTracking.invoiceNum }}</span>
          </div>

          <!-- table (s) -->
          <table class="tableX noLine">
            <colgroup>
              <col style="width:auto" span="3" />
            </colgroup>
            <thead>
              <tr>
                <th scope="col">처리일시</th>
                <th scope="col">현재 위치</th>
                <th scope="col">상태</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(trackingInfo, index) in trackingInfoList" :key="index">
                <td>{{ trackingInfo.timeString }}</td>
                <td>{{ trackingInfo.where }}</td>
                <td :class="{ pointC1: trackingInfo.kind == '배달완료' }">{{ trackingInfo.kind }}</td>
              </tr>
            </tbody>
          </table>
          <!-- table (e) -->
        </section>
      </div>

      <QuickMenu></QuickMenu>
    </div>
    <!-- container(e) -->
    <!--<footer class="footer"></footer>-->
  </div>
  <!-- wrapper(e) -->
</template>
<script>
import ApiService from '@/common/api.service';
import { isEmpty } from '@/common/common.function';
import QuickMenu from '@/views/app/comm/QuickMenu'; 

export default {
  name: 'guestOrderDelivery',
  components: {
    QuickMenu,
  },
  data() {
    return {
      headerTitle: '배송조회',

      productObj: {},
      serviceAuthTracking: {},
      trackingInfoList: [],
    };
  },
  mounted() {
    this.productObj = this.$route.params;

    this.selectServiceAuthTracking();
  },
  methods: {
    selectServiceAuthTracking() {
      let url = '';
      if (this.productObj.cellNum == null) {
        if (isEmpty(this.productObj.orderId) || isEmpty(this.productObj.courierType) || isEmpty(this.productObj.invoiceNum)) {
          return false;
        }
        url = '/service/auth/tracking/' + this.productObj.orderId + '/' + this.productObj.courierType + '/' + this.productObj.invoiceNum;
      } else {
        url = '/order/nonmember/' + this.productObj.orderId + '/mobile/' + this.productObj.cellNum + '/tracking';
      }

      ApiService.service('GET', url)
        .then(({ data }) => {
          console.log(data);
          this.serviceAuthTracking = data.result;

          if (!isEmpty(this.serviceAuthTracking)) {
            this.trackingInfoList = this.serviceAuthTracking.trackingDetails;

            function custonSort(a, b) {
              if (a.timeString < b.timeString) return -1;
              if (a.timeString > b.timeString) return 1;
              return 0;
            }

            this.trackingInfoList.sort(custonSort);
          } 
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
  },
};
</script>
